import { useCallback, useState } from "react";

const useReactHookForm = (initialState) => {
  const [data, setData] = useState(initialState);

  const updateData = useCallback((newData) => {
    setData((prevData) => ({ ...prevData, ...newData }));
  }, []);

  return [data, updateData];
};

export default useReactHookForm;
